import { data } from '../../svg/Synchronize/data';
import { makeIcon } from '../makeIcon';

export const Synchronize = makeIcon(data, 'synchronize', 'Synchronize');

export default Synchronize;
